import { Text } from '@antimatterhq/ui/components/typography';
import { useConfigDataSource } from '@/contexts/ConfigDataSourceContext';

export const PresetHeading = () => {
  const { preset } = useConfigDataSource();

  if (!preset) {
    return null;
  }

  return (
    <div className="flex items-center gap-4 py-3">
      <div>
        <img
          className="h-16 overflow-hidden object-contain"
          src={preset.iconURL ?? '/images/default_icon.png'}
          alt={preset.name ?? ''}
          data-testid={'preset-datasource-icon'}
        />
      </div>
      <div className="flex-1">
        <Text
          size="lg"
          bold
          data-testid="preset-datasource-title"
          className="block"
        >
          {preset.title}
        </Text>
        <Text
          size="sm"
          color="secondary"
          data-testid="preset-datasource-description"
          className="block"
        >
          {preset.description}
        </Text>
      </div>
    </div>
  );
};
